module.exports = __webpack_public_path__ + "static/img/logo_go_ship.4911dc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/logo_go_ship.svg
// module id = wq2Y
// module chunks = 31